import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FaRegEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  GetScienceQuestionDetails,
  GetEnglishQuestionDetails,
  GetEnglishScenarioDetails,
  GetScenarioDetails,
  GetQuestionDetails,
} from "../../ReusableComponents/CommonApis";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { Row, Col } from "react-bootstrap";
// import { Alert } from "../../Student/Reusablecomponents/RegularFunctions";
// import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
const Qstatus = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const [QSDetails, SetQSDetails] = useState();
  const [SDetails, SetSDetails] = useState();
  const [QDetails, SetQDetails] = useState();
  const [QVStatus, SetQVStatus] = useState(0);
  const [Load, SetLoad] = useState(false);

  const GetQuestionStatus = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQuestionsByVerificationStatus?QuestionVerificationStatus=${QVStatus}&SubjectId=${items?.subjectId}&QBCategoryCode=${location.state?.Tab}&QBCreatorUserId=0&RepType=QStatus&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.questionId) {
          SetQSDetails(res.data);
        } else {
          SetQSDetails(process.env.REACT_APP_NODATAFOUND);
        }
        if (location.state?.Tab !== "DQ") {
          GetScenarioQuestionStatus("For_Scenario");
        }
        GetScenarioQuestionStatus("For_Question");
      })
      .catch((err) => console.log(err));
  };

  const GetScenarioQuestionStatus = async (SType) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetScenariosandQuestionwithoutsource?StatementType=${SType}&SubjectId=${items?.subjectId}&QBCategoryCode=${location.state?.Tab}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectID) {
          if (SType === "For_Scenario") {
            SetSDetails(res.data);
          } else {
            SetQDetails(res.data);
          }
        } else {
          if (SType === "For_Scenario") {
            SetSDetails(process.env.REACT_APP_NODATAFOUND);
          } else {
            SetQDetails(process.env.REACT_APP_NODATAFOUND);
          }
        }
        SetLoad(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    GetQuestionStatus();
  }, [location.state?.Tab, QVStatus]);
  const QSColumns = [
    { name: "Question Source", selector: "qSource", sortable: true },
    {
      name: "Question verification status",
      selector: "lovDescription",
      sortable: true,
    },
    ...(location.state?.Tab !== "DQ"
      ? [
          {
            name: "Scenario Number",
            selector: "scenarioID",
            sortable: true,
            cell: (row) => (
              <div
                className="LinkStyles"
                onClick={() => NavigateScenario(row.scenarioID, true)}
              >
                {row.scenarioID !== 0 && row.scenarioID}{" "}
              </div>
            ),
          },
        ]
      : []),
    {
      name: "Question Number",
      selector: "questionId",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          onClick={() => {
            if (location.state?.Tab !== "DQ" && row.scenarioID) {
              NavigateScenario(row.scenarioID, false, true);
              NavigateQuestion(row.questionId, false);
            } else {
              NavigateQuestion(row.questionId, true);
            }
          }}
        >
          {row.questionId}{" "}
        </div>
      ),
    },
  ];

  const ScenarioColumns = [
    { name: "Scenario Numbers", selector: "scenarioID", sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <FaRegEdit
            className="CPointer"
            onClick={() => NavigateScenario(row.scenarioID, true)}
          />{" "}
        </div>
      ),
    },
  ];

  const QuestionColumns = [
    ...(location.state?.Tab !== "DQ"
      ? [
          {
            name: "Scenario Numbers",
            selector: "scenarioID",
            sortable: true,
            cell: (row) => (
              <div
                className="LinkStyles"
                onClick={() => NavigateScenario(row.scenarioID, true)}
              >
                {row.scenarioID !== 0 && row.scenarioID}
              </div>
            ),
          },
        ]
      : []),
    {
      name: "Question Numbers",
      selector: "questionID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          onClick={() => {
            if (location.state?.Tab !== "DQ" && row.scenarioID) {
              NavigateScenario(row.scenarioID, false, true);
              NavigateQuestion(row.questionID, false);
            } else {
              NavigateQuestion(row.questionID, true);
            }
          }}
        >
          {row.questionID}{" "}
        </div>
      ),
    },
  ];

  const QSDropdown = [
    { display: "All", value: 0 },
    { display: "Verify", value: 3302 },
    { display: "Correction", value: 3300 },
    { display: "Re-verify", value: 3301 },
  ];
  const NavigateQuestion = (QId, Scenario) => {
    switch (items?.subjectId) {
      case "1":
        GetQuestionDetails(
          SelectLanguage,
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
      case "2":
        GetScienceQuestionDetails(
          SelectLanguage,
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
        default:
        GetEnglishQuestionDetails(
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
    }
  };

  const NavigateScenario = (SId, Scenario, Naviagtion) => {
    switch (true) {
      case ["3", "4", "5"].includes(items?.subjectId):
        GetEnglishScenarioDetails(
          SId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario,
          Naviagtion
        );
        break;
      default:
        GetScenarioDetails(
          SelectLanguage,
          SId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Naviagtion
        );
        break;
    }
  };
  return (
    <>
      {/* <Alert /> */}
      <div className="dflex alignitems JSBetween mt-3 mb-3">
        <div className="SubHeading ">Question Status</div>
        <div className="InputFIlters">
          <label>Question Verification Status</label>
          <div className="dflex gap-3">
            {QSDropdown?.map((item) => (
              <div key={item.value} className="alignitems dflex gap-1">
                {" "}
                <input
                  type="radio"
                  value={item.value}
                  name="QVS"
                  checked={parseInt(item.value) === QVStatus}
                  onChange={(e) => SetQVStatus(parseInt(e.target.value))}
                />{" "}
                {item.display}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="Card">
        {QSDetails && (
          <DataTable
            data={QSDetails}
            columns={QSColumns}
            className="NCLDataTable"
            Dropdownvalues={["10", "25", "50", "100"]}
            ShowPagination="true"
            ShowPagecount="true"
          />
        )}
      </div>
      <div className=" mt-4">
        <Row>
          {location.state?.Tab !== "DQ" && (
            <Col>
              <div className="SubHeading ">Scenarios without source</div>
              <div className="Card mt-2">
                {SDetails && (
                  <DataTable
                    data={SDetails}
                    columns={ScenarioColumns}
                    className="NCLDataTable"
                    Dropdownvalues={["10", "25", "50", "100"]}
                    ShowPagination="true"
                    ShowPagecount="true"
                  />
                )}
              </div>
            </Col>
          )}
          <Col>
            <div className="SubHeading  "> Questions without source</div>
            <div className="Card mt-2">
              {QDetails && (
                <DataTable
                  data={QDetails}
                  columns={QuestionColumns}
                  className="NCLDataTable"
                  Dropdownvalues={["10", "25", "50", "100"]}
                  ShowPagination="true"
                  ShowPagecount="true"
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default Qstatus;
